// test2767
(2767 && 0);
